﻿import { acceptHMRUpdate, defineStore } from 'pinia'
import type { EventTypeDto } from '@/types'
import { getAllEventTypes } from '@/api'
import { reactive } from 'vue'
import { json } from 'stream/consumers'

export interface UseEventTypeStore {
    eventTypes: EventTypeDto[]

    getEventType(id: number): EventTypeDto | undefined

    loadAll(): Promise<void>
}
export const useEventTypeStore = defineStore('eventType', function (): UseEventTypeStore {
    const eventTypes = reactive<EventTypeDto[]>([])

    function getEventType(id: number): EventTypeDto | undefined {
        return eventTypes.find((et: EventTypeDto) => et.id === id)
    }
    async function loadAll() {
        if (eventTypes.length === 0) {
            eventTypes.push(...(await getAllEventTypes()))            
        }
        //        console.log('eventTypes', JSON.stringify( eventTypes))
    }
    return { eventTypes, getEventType, loadAll }
})
// make sure to pass the right store definition, `useAuth` in this case.
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useEventTypeStore, import.meta.hot))
}
